export const BOOXI_LANGUAGES = {
  en: 'eng',
  fr: 'fre',
  es: 'spa',
  pt: 'por',
  nl: 'nld',
  de: 'deu',
  it: 'ita',
  ja: 'jpn',
  zh: 'yue',
  default: 'en'
};

export const BOOXI_ADA_LANGUAGES = {
  en: 'en',
  fr: 'fr',
  default: 'en'
};

export const BOOXI_QUERY_PARAMETER = 'booxi';

export const BOOXI_STANDARD_URL = 'https://www.booxi.eu/api/booknow.js';
export const BOOXI_ADA_URL = 'https://www.booxi.eu/booknow/booknow.js';



// WEBPACK FOOTER //
// ./src/settings/booxi.js